import * as React from "react"

export default function GoogleColorIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M23 12.233c0-.863-.07-1.493-.226-2.147h-10.06v3.897h5.906c-.12.968-.762 2.427-2.19 3.407l-.02.13 3.18 2.415.22.021C21.834 18.125 23 15.43 23 12.233"
        fill="#4285F4"
      />
      <path
        d="M12.716 22.5c2.893 0 5.321-.933 7.095-2.543l-3.38-2.567c-.906.618-2.12 1.05-3.715 1.05a6.438 6.438 0 01-6.095-4.363l-.126.01-3.307 2.509-.043.117c1.761 3.43 5.38 5.787 9.57 5.787z"
        fill="#34A853"
      />
      <path
        d="M6.619 14.076A6.347 6.347 0 016.262 12c0-.724.13-1.424.345-2.077l-.006-.139-3.349-2.549-.11.051A10.339 10.339 0 002 12c0 1.691.417 3.29 1.143 4.713l3.476-2.637"
        fill="#FBBC05"
      />
      <path
        d="M12.716 5.56c2.012 0 3.369.852 4.143 1.563l3.024-2.893c-1.857-1.692-4.274-2.73-7.167-2.73-4.19 0-7.81 2.357-9.571 5.787l3.464 2.636a6.465 6.465 0 016.107-4.363"
        fill="#EB4335"
      />
    </svg>
  )
}
